import { FC } from 'react'
import { ProfileCardSizingContainer } from '@components-v2/molecules/ProfileCardSizingContainer'
import { AvatarTextCard } from '@components-v2/molecules/AvatarTextCard'

type Props = {
  src: string
  title: string
  subtitle: string
  supportingText?: string
  href?: string
  size?: 'small' | 'medium' | 'large'
  withVerifiedTick?: boolean
}

/**
 * Profile ページで使用するカード
 */
export const ProfileCard: FC<Props> = ({
  src,
  title,
  subtitle,
  supportingText,
  href,
  size = 'medium',
  withVerifiedTick = false,
}) => {
  return (
    <ProfileCardSizingContainer>
      <AvatarTextCard
        src={src}
        title={title}
        subtitle={subtitle}
        supportingText={supportingText}
        href={href}
        size={size}
        withVerifiedTick={withVerifiedTick}
      />
    </ProfileCardSizingContainer>
  )
}
